import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { useGlobalStore } from '@/entities/GlobalStore';
import { deposit } from '../api/deposit';

type Props = {
    date: string;
    time: string;
};

export const useDepositQuery = ({ date, time }: Props) => {
    const { setConsultationParams } = useGlobalStore();
    const { setErrorModalProps, setIsSuccessFormSentModalOpen, setIsDepositModalOpen } = useModalStore();

    return useMutation({
        mutationFn: deposit,
        onSuccess: () => {
            setIsDepositModalOpen(false);
            setConsultationParams({ date, time, reason: 'Deposit' });
            setIsSuccessFormSentModalOpen(true);
        },
        onError: (error: ResponseError) => {
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            setErrorModalProps({ isOpened: true, title: errorMessage });
        },
    });
};
